import { DckActionTypes } from "dck-redux"
import moment from "moment"
import { all, takeEvery } from "redux-saga/effects"
import { formatCollateralName, HTTP_VERB } from "../../../lib/utils"
import * as ItemTypes from "../../items/types"
import apiServerConstants from "../apiServerConstants"
import { makeSagaQuery } from "../utils"

function *loadOrganizationsSaga() {

  yield makeSagaQuery(
    `${apiServerConstants.host}/organizations?page=${0}&size=${1000000}`, 
    HTTP_VERB.GET,
    null,
    ItemTypes.Organization,
    true,
    response => {

      let organizations = response.body
      if (!(organizations instanceof Array)) return

      organizations = organizations.map(item => {

        const { openedOn, loanCollaterals } = item
        item.openedOnFormatted = moment(openedOn).format('ll')
        item.collaterals = loanCollaterals 
          ? loanCollaterals.map(value => formatCollateralName(value)).join(', ')
          : ''
        return item
      })

      return {
        type: DckActionTypes.ITEMS_SET,
        itemType: ItemTypes.Organization,
        data: organizations
      }
    }
  )
}

function* organizationsSaga() {
  yield all([
    takeEvery(
      action =>
        action.type === DckActionTypes.ITEMS_LOAD &&
        action.itemType === ItemTypes.Organization,
      loadOrganizationsSaga
    ),
  ])
}

export default organizationsSaga


// WEBPACK FOOTER //
// ./src/redux/sagas/items/organizations.js